
import { Vue, Component, Watch, Prop, Model } from 'vue-property-decorator';
import moment, { Moment } from 'moment';

@Component({})
export default class OnSiteService extends Vue {
  val: any = {};

  @Model('change')
  value!: any;

  @Prop()
  shopLicenseValidDateType?: any;

  @Watch('val', { deep: true })
  watchInternalVal() {
    const data: any = {
      shopLicenseValidUntil: '',
      shopLicenseValidDateType: '',
    };
    if (this.val.shopLicenseValidUntil.length > 0) {
      data.shopLicenseValidUntil = `${this.val.shopLicenseValidUntil[0].format('YYYY-MM-DD')}~${this.val.shopLicenseValidUntil[1].format('YYYY-MM-DD')}`;
    }
    data.shopLicenseValidDateType = this.val.shopLicenseValidDateType;
    if (data.shopLicenseValidDateType === 2) {
      data.shopLicenseValidUntil = '';
    }
    this.$emit('change', data);
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = this.shopLicenseValidDateType;
      const { shopLicenseValidUntil } = this.shopLicenseValidDateType;
      if (shopLicenseValidUntil) {
        if (shopLicenseValidUntil.indexOf('~') > -1) {
          const year = shopLicenseValidUntil.split('~');
          this.val.shopLicenseValidUntil = [moment(year[0]), moment(year[1])];
        }
      } else {
        this.val.shopLicenseValidUntil = [];
      }
    }
  }


  /**
   * 处理日期面板变化事件
   * @param {Moment} val - 变化后的日期值
   */
  onPanelChange(val: Moment) {
    this.val.shopLicenseValidUntil = val;
  }

  changeVal(e: any) {
    this.val.shopLicenseValidUntil = [];
    this.val.shopLicenseValidDateType = e.target.value;
  }

  mounted() {
    this.watchValue();
    this.$emit('updateSubmittable', true);
  }
}
